import { __assign } from "tslib";
// DS: C44
/** Popover showing information about a hovered user */
import React, { useContext } from 'react';
import classnames from 'classnames';
import { compose } from 'redux';
import UserAvatarPopoverContent from './UserAvatarPopoverContent';
import PopoverOnHover from '../../Popover/PopoverOnHover';
import { ThemeOptions } from '@wix/da-react-context/pkg/ThemeContext';
import { withLogBiEvent, } from '../../biLogger/hocs/withLogBiEvent';
import UserAvatarPopoverButtonsContext from './UserAvatarPopoverButtonsContext';
import { withMobileContext, } from '@wix/da-react-context/pkg/MobileContext';
import { BiContext, BiLoggerContextProvider, } from '../../biLogger/BiLogger.context';
import s from './UserAvatarPopover.scss';
var HOVER_DELAY = 500;
export var UserAvatarPopover = function (props) {
    var data = props.data, isError = props.isError, isOwner = props.isOwner, isLoading = props.isLoading, children = props.children, className = props.className, isMobile = props.isMobile, onStartChat = props.onStartChat, relatedItemBiData = props.relatedItemBiData;
    var PopoverContent = function () {
        var biContext = useContext(BiContext);
        var withButtons = useContext(UserAvatarPopoverButtonsContext);
        if (isError || !data) {
            return null;
        }
        return (React.createElement("div", { className: classnames(s['tooltip'], (!withButtons || isOwner) && s['without-buttons']) }, !isError && data && (React.createElement(BiLoggerContextProvider, { value: {
                widgetname: 'user_popup',
                sectionname: biContext.sectionname && biContext.sectionname + "_popup",
            } },
            React.createElement(UserAvatarPopoverContent, __assign({ withButtons: !isOwner && withButtons, onStartChat: onStartChat, relatedItemBiData: relatedItemBiData }, data))))));
    };
    var onVisible = function () {
        if (props.biData) {
            props.logBiEvent(props.biData);
        }
        if (!props.isInitialized) {
            props.initialize(props.username);
        }
    };
    if (isMobile) {
        return React.createElement(React.Fragment, null, children);
    }
    return (React.createElement(PopoverOnHover, { className: classnames(s['popover-root'], isLoading && s['loading'], className), contentClassName: s['tooltip-content'], arrowClassName: s['tooltip-arrow'], popoverContent: React.createElement(PopoverContent, null), noPadding: true, hoverDelay: HOVER_DELAY, isOpen: !!data, onVisible: onVisible, showArrow: false, forceTheme: ThemeOptions.DARK }, children));
};
export default compose(withMobileContext, withLogBiEvent)(UserAvatarPopover);
//# sourceMappingURL=UserAvatarPopover.js.map